import moment from "moment";
import sanitizeHtml from 'sanitize-html';
import isEqual from "lodash/isEqual.js";

export interface Validation {
    name: string,
    message: string,
    valid: boolean
}

type typeConvert = "minutes" | "hours" | "days" | "months" | "years";

export default class TextTools {

    getMomentDiff(dateDiff: any, type: typeConvert) {
        const momentDateTimeNow = moment(new Date());
        return momentDateTimeNow.diff(moment(dateDiff), type);
    }

    getMomentDiffDatas(primeiraData: any, segundaData: any, type: typeConvert) {
        return moment(primeiraData).diff(moment(segundaData), type);
    }

    getDateFormat(date: any, format: string) {
        return moment(date).format(format);
    }

    cleanTagEmailParse(text: string) {
        const tags = {
            allowedTags: ['br', 'p', 'div', 'span', 'b', 'i', 'a', 'img', "strong", "em",],
        };

        const splitList = text ? text.split(" ") : [];

        let unionString = "";

        splitList.map(x =>
            unionString += ((x.includes(".com.br>") || x.includes(".com>") || x.includes(".com.br") || x.includes(".com"))
                ? x.replaceAll("<", "&lt;").replaceAll(">", "&gt;")
                : x) + " "
        );

        let result = sanitizeHtml(unionString, tags);

        return result;
    }

    cleanOnlyEmailParse(text: string) {
        const splitList = text ? text.split(" ") : [];

        let unionString = "";

        splitList.map(x =>
            unionString += ((x.includes(".com.br>") || x.includes(".com>") || x.includes(".com.br") || x.includes(".com") || x.includes('.org') || x.includes('.net')
                || x.includes('.edu') || x.includes('.gov') || x.includes('.info') || x.includes('.biz') || x.includes('.io') || x.includes('.br') || x.includes('.care'))
                ? x.replaceAll("<", "&lt;").replaceAll(">", "&gt;")
                : x) + " "
        );

        unionString = unionString.replaceAll("&lt;br/&gt;", "<br/>").replaceAll("&lt;br&gt;", "<br>").replaceAll("&lt;br /&gt;", "<br />");

        return unionString;
    }

    cleanAllTags(text: string) {
        return sanitizeHtml(text ?? "", { allowedTags: [] },);
    }

    cleanTagsMinusTable(text: string) {
        const tags = {
            allowedTags: ['table', 'colgroup', 'col', 'tbody', 'tr', 'td', "br", "div", "\n"],
            allowedAttributes: {
                'table': ["style"],
                'colgroup': ["style"],
                'tbody': ["style"],
                'tr': ["style"],
                'td': ["style"],
            }
        };

        return sanitizeHtml(text ?? "", tags);
    }

    compareObjects(obj1: any, obj2: any) {
        return isEqual(obj1, obj2);
    }

    mountDropList(list: any[]) {
        let result = [];

        if (list.length > 0) {
            let _list = list
                .filter(c => (c.disabled) ? c.disabled === 0 || c.disabled === false : c)
                .map(c => {
                    return {
                        label: (c.nome) ? c.nome : ((c.name) ? c.name : c.description),
                        value: (c.idUser) ? c.idUser : c.id
                    }
                })
                .sort((a, b) => { return a.label > b.label ? 1 : -1 })

            return [...result, ..._list];
        }
        else {
            return result;
        }
    }

    mountDropTeamsList(list: any[]) {
        let result: any[] = [];

        if (list.length > 0) {
            list.forEach(c => {
                if (result.filter(x => x.description === c.equipeAtual).length === 0) {
                    var ttt = {
                        description: c.equipeAtual,
                        open: parseInt(c.abertas),
                        closed: parseInt(c.fechadas),
                        type: "Equipe"
                    }

                    result.push(ttt);
                }
                else {
                    var resultItem = result.find(x => x.description === c.equipeAtual);
                    result = result.filter(x => x !== resultItem);

                    resultItem = {
                        description: c.equipeAtual,
                        open: resultItem.open + parseInt(c.abertas),
                        closed: resultItem.closed + parseInt(c.fechadas),
                        type: "Equipe"
                    }

                    result.push(resultItem);
                }
            })

            result = result.sort((a, b) => { return (a.open + a.closed) < (b.open + b.closed) ? 1 : -1 })

            return result;
        }
        else {
            return result;
        }
    }

    mountDropAttendantList(list: any[]) {
        let result: any[] = [];

        if (list.length > 0) {
            list.forEach(c => {
                if (result.filter(x => x.description === c.atendenteAtual).length === 0) {
                    var ttt = {
                        description: c.atendenteAtual,
                        open: parseInt(c.abertas),
                        closed: parseInt(c.fechadas),
                        type: "Atendente"
                    }

                    result.push(ttt);
                }
                else {
                    var resultItem = result.find(x => x.description === c.atendenteAtual);
                    result = result.filter(x => x !== resultItem);

                    resultItem = {
                        description: c.atendenteAtual,
                        open: resultItem.open + parseInt(c.abertas),
                        closed: resultItem.closed + parseInt(c.fechadas),
                        type: "Atendente"
                    }

                    result.push(resultItem);
                }
            })

            result = result.sort((a, b) => { return (a.open + a.closed) < (b.open + b.closed) ? 1 : -1 })

            return result;
        }
        else {
            return result;
        }
    }

    mountDropAreaSelectionList(list: any[], valueSelected?: any) {
        let result = [{
            label: "Todas as áreas",
            text: "Todas as áreas",
            value: 0,
            default: (valueSelected === 0) ? true : false,
            fields: [{
                name: "Todas as áreas",
                value: "Todas as áreas",
            }]
        }];

        if (list.length > 0) {
            let _list = list
                .map(c => {
                    return {
                        label: c.description,
                        text: c.description,
                        value: c.id,
                        default: (valueSelected && c.id === valueSelected) ? true : false,
                        fields: [{
                            name: c.description,
                            value: c.description,
                        }]
                    }
                })
                .sort((a, b) => { return a.value > b.value ? 1 : -1 })

            return [...result, ..._list];
        }
        else {
            return result;
        }
    }

    filterSelectedList(list: any[], filterList: any[]) {
        var listReturn = list
            .map(item => {
                let filter: any;

                filter = filterList.find(i => i === item.id);

                if (filter === undefined) {
                    filter = filterList.find(i => i === item.value);
                }

                if (filter !== undefined && filter !== null) {
                    return {
                        label: (item.name)
                            ? item.name
                            : (item.description)
                                ? item.description
                                : (item.label)
                                    ? item.label
                                    : "",
                        value: (item.id) ? item.id : item.value,
                        selected: true
                    }
                }
                else {
                    return {
                        label: (item.name)
                            ? item.name
                            : (item.description)
                                ? item.description
                                : (item.label)
                                    ? item.label
                                    : (item.nome)
                                        ? item.nome
                                        : "",
                        value: (item.id)
                            ? item.id
                            : (item.value)
                                ? item.value
                                : (item.idUser)
                                    ? item.idUser
                                    : 0
                    }
                }
            })
            .sort((a, b) => {
                return (a.label > b.label) ? 1 : -1
            });

        return listReturn;
    }

    compareArrays(arr1: any, arr2: any) {
        if (arr1.length !== arr2.length) {
            return false;
        }

        arr1.sort();
        arr2.sort();

        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }

        return true;
    }

    cleanCss(text: string) {
        const tags = {
            allowedTags: [
                "address", "article", "aside", "footer", "header", "h1", "h2", "h3", "h4",
                "h5", "h6", "hgroup", "main", "nav", "section", "blockquote", "dd", "div",
                "dl", "dt", "figcaption", "figure", "hr", "li", "main", "ol", "p", "pre",
                "ul", "a", "abbr", "b", "bdi", "bdo", "br", "cite", "code", "data", "dfn",
                "em", "i", "kbd", "mark", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp",
                "small", "span", "strong", "sub", "sup", "time", "u", "var", "wbr", "caption",
                "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "html", "body", "div", "head"
            ],
        };

        return sanitizeHtml(text ?? "", tags);
    }

    cleanDetails(text: string) {
        text = (text.includes("<body")) ? text.replace("<body", "<body style=\"background-color: initial;\"") : text;
        text = text.replaceAll('htmlxmlns:x="urn:schemas-microsoft-com:office:excel"', "html");
        text = text.replaceAll("\r\n", "");
        return text;
    }

    convertDateStringDDMMYYYY(dateString: string) {
        const partes = dateString.split(' ');
        const dataPartes = partes[0].split('/');
        const horaPartes = partes[1].split(':');

        const dia = parseInt(dataPartes[0]);
        const mes = parseInt(dataPartes[1]) - 1; // Mês começa em 0 no JavaScript
        const ano = parseInt(dataPartes[2]);

        const hora = parseInt(horaPartes[0]);
        const minutos = parseInt(horaPartes[1]);
        const segundos = parseInt(horaPartes[2]);

        const data = new Date(ano, mes, dia, hora, minutos, segundos);

        return data;
    }

    removeHtmlTags(text: string) {
        const regexFontFamily = /font-family:\s*(?:(['"])[^'"]*\1|&quot;[^&]*&quot;|[^;])+;?/gi;
        const regexBackgroundColor = /background-color:\s*[^;]+;?/gi;
        const regexColor = /color:\s*[^;]+;?/gi;
        const regexClass = /class="[^"]*"/gi;
        const regexDir = /dir="[^"]*"/gi;

        text = text
            .replaceAll(regexFontFamily, '')
            .replaceAll(regexBackgroundColor, '')
            .replaceAll(regexColor, '')
            .replaceAll(regexClass, '')
            .replaceAll(regexDir, '');

        return text;
    }

    cleanText(text: any) {
        // // Verifica se a entrada é uma string, caso contrário, converte para uma string vazia
        // if (typeof text !== 'string') {
        //     console.warn('Entrada não é uma string. Convertendo para string vazia.');
        //     text = '';
        // }

        // // Remove todas as tags HTML, incluindo as que têm CSS embutido
        // let clean = text.replace(/<[^>]*>/g, '');

        // // Substitui múltiplos espaços por um único espaço
        // clean = clean.replace(/\s+/g, ' ');

        // // Mantém as quebras de linha
        // clean = clean.replace(/ \n/g, '\n').replace(/\n /g, '\n');

        // // clean = clean.replaceAll("&nbsp;", ' ');
        // // clean = clean.replace("&nbsp;", ' ');

        // return clean.trim();

        let formattedText = text.replaceAll(/<\/div><div>/g, '\n ').replace(/<\/?div>/g, '');
        return sanitizeHtml(formattedText ?? "", { allowedTags: [] },);
    }

    static treatFile(file: any) {
        const specialCharactersRegex = /[^a-zA-Z0-9\s.]/g;
        const cleanedName = file.name.replace(specialCharactersRegex, '');
        return cleanedName;
    }
}